{
  "es": {
    "todo_v2": {
      "actions": {
        "confirm": "Marcar como completada",
        "create": "Tarea",
        "reopen": "Reabrir",
        "update": "Editar tarea"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Empleado",
        "partner": "Colaborador"
      },
      "attributes": {
        "assignees": "Responsables",
        "created_at": "Creado",
        "due_date": "Fecha límite",
        "project": "Proyecto",
        "status": "Estado",
        "todo_group": "Tarea",
        "unit": "Unidad"
      },
      "labels": {
        "add_assignee": "Añadir un responsable…",
        "add_customers": "Añadir clientes",
        "completed": "Completadas",
        "confirm_message": "¿Seguro que quieres marcar esta tarea como completada?",
        "customers": "Clientes",
        "group_already_added": "Esta tarea ya está añadida a esta unidad.",
        "my_todos": "Mis tareas",
        "no_assignees": "Todavía no hay responsables.",
        "no_todos": "Todavía no hay tareas.",
        "no_todos_group": "Todavía no hay tareas en este grupo.",
        "no_todos_unit": "Todavía no hay tareas para esta unidad.",
        "publish_all": "Publicar todo",
        "publish_customers": "Publicar para los clientes de cada unidad",
        "published": "Publicada",
        "required": "Este campo es obligatorio",
        "select_group": "Selecciona una tarea",
        "upload_hint": "Sube el documento o los documentos solicitados para completar esta tarea.",
        "uploaded_documents": "Documentos subidos"
      },
      "statuses": {
        "completed": "Completada",
        "draft": "Borrador",
        "pending": "Pendiente"
      },
      "toasts": {
        "completed": "Tarea completada",
        "create": "Tarea creada",
        "delete": "Tarea eliminada",
        "uncompleted": "Tarea reabierta",
        "update": "Tarea actualizada"
      }
    }
  }
}
